// Время в запросах о матчах. Копия логики приложения
// (ingame-admin/src/utilities/time.js и proMatch.toServerEventTime).

const pad = (n) => String(n).padStart(2, '0');

// Минута события может быть больше 59 (тайм 45 минут — 75-я минута),
// а в базе это TIME: переводим в ЧЧ:ММ:СС, иначе уйдёт «00:75:12»
export const toServerEventTime = (minutes, seconds = 0) => {
  const total = Math.max(0, Math.floor(Number(minutes) || 0) * 60 + Math.floor(Number(seconds) || 0));
  return `${pad(Math.floor(total / 3600))}:${pad(Math.floor((total % 3600) / 60))}:${pad(total % 60)}`;
};

const TIME_RE = /^([01]\d|2[0-3]):([0-5]\d)(:[0-5]\d)?$/;

// Время начала матча: пустое допустимо (не назначено)
export const isValidTime = (value) => {
  if (value === null || value === undefined || value === '') return true;
  return TIME_RE.test(String(value));
};

// ЧЧ:ММ -> ЧЧ:ММ:00; пустое или неверное -> null
export const toServerTime = (value) => {
  if (!value) return null;
  const match = TIME_RE.exec(String(value));
  if (!match) return null;
  return `${match[1]}:${match[2]}:00`;
};
